import script from "./staff.vue?vue&type=script&setup=true&lang=js"
export * from "./staff.vue?vue&type=script&setup=true&lang=js"

import "./staff.vue?vue&type=style&index=0&id=6516e8c2&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6516e8c2"]])

export default __exports__